import script from "./ReportVisitItemFormDrawer.vue?vue&type=script&setup=true&lang=js"
export * from "./ReportVisitItemFormDrawer.vue?vue&type=script&setup=true&lang=js"

import "./ReportVisitItemFormDrawer.vue?vue&type=style&index=0&id=4cb09f20&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4cb09f20"]])

export default __exports__